
module.exports = global.config = {
  PROJECTS_URL: "https://m5tx556ood.execute-api.us-east-2.amazonaws.com/Prod/api/projects/",
  PUBLIC_URL:   "https://m5tx556ood.execute-api.us-east-2.amazonaws.com/Prod/api/public-projects",
  LOGIN_URL:    "https://m5tx556ood.execute-api.us-east-2.amazonaws.com/Prod/api/user/login/",
  SIGNUP_URL:   "https://m5tx556ood.execute-api.us-east-2.amazonaws.com/Prod/api/user/signup/",
};